export const ICON_TYPE = {
  SHOP_ICON: "shop",
  DASHBOARD_ICON: "dashboard",
  VIEW_ICON: "view",
  PROFILE_ICON: "profile",
  LIVEFARE_ICON: "livefare",
  REALTIMEGDS_ICON: "realtimegds",
  QUICKACCESS_ICON: "quickaccess",
  LEGACY_ICON: "legacy"
};

export const SIDEBAR_CONSTANTS = {
  SHOP_MANAGER: {
    title: "Shop Manager",
    path: "/shop_manager"
  },
  DASHBOARD_MANAGER: {
    title: "Dashboard Manager",
    path: "/dashboard_manager"
  },
  VIEW_DASHBOARD: {
    title: "View Dashboard",
    path: "/view_dashboard"
  },
  LEGACY_DASHBOARD: {
    title: "Legacy Dashboard",
    path: "/legacy_dashboard"
  },
  MY_PROFILE: {
    title: "My Profile",
    path: "/myprofile"
  },
  QUICK_ACCESS: {
    title: "Quick Access",
    path: "/quick_access"
  }
};

export const SIDEBAR_RESULT = {
  QUICKACCESS: {
    data: SIDEBAR_CONSTANTS?.QUICK_ACCESS,
    icon: ICON_TYPE?.QUICKACCESS_ICON,
  },
  FLIGHT_SHOP: {
    data: SIDEBAR_CONSTANTS?.SHOP_MANAGER,
    icon: ICON_TYPE?.SHOP_ICON,
  },
  OPTIMIZE_SHOP: {
    data: SIDEBAR_CONSTANTS?.DASHBOARD_MANAGER,
    icon: ICON_TYPE?.DASHBOARD_ICON,
  },

  LEGACY_DASHBOARD: {
    data: SIDEBAR_CONSTANTS?.LEGACY_DASHBOARD,
    icon: ICON_TYPE?.LEGACY_ICON,
  },
  PROFILE: {
    data: SIDEBAR_CONSTANTS?.MY_PROFILE,
    icon: ICON_TYPE?.PROFILE_ICON,
  }
};

export const LEGACY_VIEW = {
  VIEWSHOP: {
    data: SIDEBAR_CONSTANTS?.VIEW_DASHBOARD,
    icon: ICON_TYPE?.VIEW_ICON,
  }
}
